import { ContentItem, BacklinkItem, KeywordItem, CompetitorItem, PusherSettings, SeoIntegrationSettings } from "./types";

export const INITIAL_CONTENT: ContentItem[] = [
  {
    id: "sl-1",
    market: "SE",
    title: "Vad är effektiv ränta (ÅOP) – Skillnaden mot nominell ränta",
    slug: "vad-ar-effektiv-ranta",
    type: "guide",
    status: "published",
    targetKeyword: "effektiv ränta lån",
    searchVolume: 4400,
    wordCount: 1450,
    scheduledDate: "2026-09-28",
    scheduledTimeWindow: "10:15",
    publishedUrl: "https://simplyloan.se/guide/vad-ar-effektiv-ranta",
    author: "SimplyLoan Redaktion",
    factChecked: true,
    internalLinksCount: 4,
    aiEditLevel: "heavy",
    notes: "Fundamentalt indhold der etablerer Topical Authority om låneomkostninger."
  },
  {
    id: "sl-2",
    market: "SE",
    title: "Kreditprövning & UC: Så påverkas din kreditvärdighet",
    slug: "kreditprovning-uc",
    type: "guide",
    status: "published",
    targetKeyword: "kreditprövning uc lån",
    searchVolume: 3200,
    wordCount: 1680,
    scheduledDate: "2026-09-30",
    scheduledTimeWindow: "13:45",
    publishedUrl: "https://simplyloan.se/guide/kreditprovning-uc",
    author: "SimplyLoan Redaktion",
    factChecked: true,
    internalLinksCount: 5,
    aiEditLevel: "heavy",
    notes: "Vigtig for konvertering til lån uden UC og samlelån."
  },
  {
    id: "sl-3",
    market: "SE",
    title: "Låna med betalningsanmärkning – Villkor och möjligheter",
    slug: "lan-med-betalingsanmarkning",
    type: "guide",
    status: "ready_buffer",
    targetKeyword: "låna med betalningsanmärkning",
    searchVolume: 8100,
    wordCount: 1820,
    scheduledDate: "2026-10-06",
    scheduledTimeWindow: "11:23",
    author: "SimplyLoan Redaktion",
    factChecked: true,
    internalLinksCount: 6,
    aiEditLevel: "heavy",
    notes: "Høj søgevolumen og høj konverteringsrate til alternative långivere."
  },
  {
    id: "sl-4",
    market: "SE",
    title: "Budgetmall & kalkyl: Få full kontroll över din privatekonomi",
    slug: "budgetmall",
    type: "guide",
    status: "ready_buffer",
    targetKeyword: "budgetmall ladda ner",
    searchVolume: 2900,
    wordCount: 1200,
    scheduledDate: "2026-10-08",
    scheduledTimeWindow: "14:10",
    author: "SimplyLoan Redaktion",
    factChecked: true,
    internalLinksCount: 3,
    aiEditLevel: "medium",
    notes: "Inkluderer downloadbar Excel-skabelon for at opnå naturlige backlinks."
  },
  {
    id: "sl-5",
    market: "SE",
    title: "Utbetalning av privatlån: Så fungerar bankdagar och handläggning",
    slug: "utbetalning-privatlan",
    type: "guide",
    status: "ready_buffer",
    targetKeyword: "lån med direkt utbetalning",
    searchVolume: 5400,
    wordCount: 1390,
    scheduledDate: "2026-10-13",
    scheduledTimeWindow: "09:45",
    author: "SimplyLoan Redaktion",
    factChecked: true,
    internalLinksCount: 4,
    aiEditLevel: "medium",
    notes: "Nøgleartikel til instant-payout lånere."
  },
  {
    id: "sl-6",
    market: "SE",
    title: "Samla smålån & snabblån – Steg för steg guide",
    slug: "samla-smalan-guide",
    type: "samla",
    status: "review",
    targetKeyword: "samla lån och krediter",
    searchVolume: 6200,
    wordCount: 2100,
    scheduledDate: null,
    scheduledTimeWindow: null,
    author: "SimplyLoan Redaktion",
    factChecked: false,
    internalLinksCount: 6,
    aiEditLevel: "heavy",
    notes: "Klar til menneskelig gennemgang og fact-check."
  },
  {
    id: "sl-7",
    market: "SE",
    title: "Låna 100 000 kr – Jämför ränta och månadskostnad",
    slug: "lana-100000-kr",
    type: "belopp",
    status: "draft",
    targetKeyword: "låna 100000 kr",
    searchVolume: 1900,
    wordCount: 950,
    scheduledDate: null,
    scheduledTimeWindow: null,
    author: "AI Assisted",
    factChecked: false,
    internalLinksCount: 2,
    aiEditLevel: "light",
    notes: "Programmatisk beløbsside kladde."
  },
  // Norwegian content
  {
    id: "sl-no-1",
    market: "NO",
    title: "Hva er effektiv rente? Slik unngår du dyre lånefeller",
    slug: "hva-er-effektiv-rente",
    type: "guide",
    status: "published",
    targetKeyword: "effektiv rente forbrukslån",
    searchVolume: 2800,
    wordCount: 1350,
    scheduledDate: "2026-09-25",
    scheduledTimeWindow: "10:30",
    publishedUrl: "https://simplyloan.no/artikler/effektiv-rente/",
    author: "SimplyLoan Norge",
    factChecked: true,
    internalLinksCount: 4,
    aiEditLevel: "heavy",
    notes: "Norsk nøgleguide."
  },
  {
    id: "sl-no-2",
    market: "NO",
    title: "Refinansiering av smålån og kredittkort i Norge",
    slug: "refinansiering-av-smalan",
    type: "samla",
    status: "ready_buffer",
    targetKeyword: "refinansiering forbrukslån",
    searchVolume: 4900,
    wordCount: 1750,
    scheduledDate: "2026-10-09",
    scheduledTimeWindow: "11:15",
    author: "SimplyLoan Norge",
    factChecked: true,
    internalLinksCount: 5,
    aiEditLevel: "heavy",
    notes: "Top-konverterende kategori i Norge."
  },
  {
    id: "sl-no-3",
    market: "NO",
    title: "Lån med betalingsanmerkning – Kan man få lån?",
    slug: "lan-med-betalingsanmerkning-no",
    type: "guide",
    status: "draft",
    targetKeyword: "lån med betalingsanmerkning norge",
    searchVolume: 3600,
    wordCount: 1100,
    scheduledDate: null,
    scheduledTimeWindow: null,
    author: "SimplyLoan Norge",
    factChecked: false,
    internalLinksCount: 2,
    aiEditLevel: "medium",
    notes: "Kladde til det norske marked."
  }
];

export const INITIAL_BACKLINKS: BacklinkItem[] = [
  {
    id: "bl-wp-se-1",
    market: "SE",
    targetPath: "/ + /guide/kreditprovning-uc/",
    anchorText: "SimplyLoan + kreditprövning utan UC",
    anchorType: "brand",
    referringDomain: "enterprisemagazine.se",
    domainRating: 68,
    linkType: "guest_post",
    costDkk: 2160,
    status: "in_progress",
    dateAcquired: "2026-11-03",
    lastCheckedDate: "2026-11-04"
  },
  {
    id: "bl-wp-se-3",
    market: "SE",
    targetPath: "/samla-lan/ + /guide/samla-lan-och-krediter/",
    anchorText: "samla lån via SimplyLoan",
    anchorType: "partial_match",
    referringDomain: "kronantillmiljonen.se",
    domainRating: 28,
    linkType: "guest_post",
    costDkk: 2400,
    status: "in_progress",
    dateAcquired: "2026-11-03",
    lastCheckedDate: "2026-11-04"
  },
  {
    id: "bl-wp-se-4",
    market: "SE",
    targetPath: "/guide/vad-ar-effektiv-ranta/ + /privatlan/",
    anchorText: "vad är effektiv ränta och hur räknar man ut den",
    anchorType: "partial_match",
    referringDomain: "maxhelp.se",
    domainRating: 32,
    linkType: "guest_post",
    costDkk: 1440,
    status: "in_progress",
    dateAcquired: "2026-11-04",
    lastCheckedDate: "2026-11-04"
  },
  {
    id: "bl-wp-se-5",
    market: "SE",
    targetPath: "/guide/kontokredit-och-kreditlan/ + /guide/lana-pengar-utan-uc-med-bankid/",
    anchorText: "jämföra kontokredit och kreditlån",
    anchorType: "partial_match",
    referringDomain: "ecommercebridge.com/sv/",
    domainRating: 57,
    linkType: "guest_post",
    costDkk: 960,
    status: "in_progress",
    dateAcquired: "2026-11-04",
    lastCheckedDate: "2026-11-04"
  }
];

export const INITIAL_KEYWORDS: KeywordItem[] = [
  {
    id: "kw-gsc-1",
    market: "SE",
    keyword: "smålån",
    currentPosition: 19.6,
    previousPosition: 20.8,
    change: 1,
    searchVolume: 5070,
    difficulty: 45,
    targetUrl: "/snabblan",
    intent: "transactional",
    status: "rising",
    lastChecked: "2026-10-02",
    gscImpressions: 1690,
    gscClicks: 9
  },
  {
    id: "kw-gsc-2",
    market: "SE",
    keyword: "simplyloan",
    currentPosition: 6.5,
    previousPosition: 7.7,
    change: 1,
    searchVolume: 200,
    difficulty: 45,
    targetUrl: "/",
    intent: "navigational",
    status: "ranking",
    lastChecked: "2026-10-02",
    gscImpressions: 15,
    gscClicks: 6
  },
  {
    id: "kw-gsc-3",
    market: "SE",
    keyword: "få lån när alla säger nej",
    currentPosition: 21.9,
    previousPosition: 23.1,
    change: 1,
    searchVolume: 828,
    difficulty: 45,
    targetUrl: "/privatlan",
    intent: "commercial",
    status: "ranking",
    lastChecked: "2026-10-02",
    gscImpressions: 276,
    gscClicks: 2
  },
  {
    id: "kw-gsc-4",
    market: "SE",
    keyword: "lån",
    currentPosition: 78.2,
    previousPosition: 79.4,
    change: 1,
    searchVolume: 507,
    difficulty: 45,
    targetUrl: "/privatlan",
    intent: "commercial",
    status: "ranking",
    lastChecked: "2026-10-02",
    gscImpressions: 169,
    gscClicks: 1
  },
  {
    id: "kw-gsc-5",
    market: "SE",
    keyword: "lån 24/7",
    currentPosition: 11,
    previousPosition: 12.2,
    change: 1,
    searchVolume: 200,
    difficulty: 45,
    targetUrl: "/privatlan",
    intent: "transactional",
    status: "rising",
    lastChecked: "2026-10-02",
    gscImpressions: 17,
    gscClicks: 1
  },
  {
    id: "kw-gsc-6",
    market: "SE",
    keyword: "lån direkt",
    currentPosition: 56.0,
    previousPosition: 57.2,
    change: 1,
    searchVolume: 200,
    difficulty: 45,
    targetUrl: "/privatlan",
    intent: "transactional",
    status: "ranking",
    lastChecked: "2026-10-02",
    gscImpressions: 35,
    gscClicks: 1
  },
  {
    id: "kw-gsc-7",
    market: "SE",
    keyword: "lån med låg ränta direkt utbetalning",
    currentPosition: 34.8,
    previousPosition: 36.0,
    change: 1,
    searchVolume: 200,
    difficulty: 45,
    targetUrl: "/privatlan",
    intent: "transactional",
    status: "ranking",
    lastChecked: "2026-10-02",
    gscImpressions: 6,
    gscClicks: 1
  },
  {
    id: "kw-gsc-8",
    market: "SE",
    keyword: "lån när alla säger nej",
    currentPosition: 21.4,
    previousPosition: 22.6,
    change: 1,
    searchVolume: 200,
    difficulty: 45,
    targetUrl: "/privatlan",
    intent: "commercial",
    status: "ranking",
    lastChecked: "2026-10-02",
    gscImpressions: 39,
    gscClicks: 1
  },
  {
    id: "kw-gsc-9",
    market: "SE",
    keyword: "låna pengar direkt",
    currentPosition: 53.7,
    previousPosition: 54.9,
    change: 1,
    searchVolume: 1032,
    difficulty: 45,
    targetUrl: "/privatlan",
    intent: "transactional",
    status: "ranking",
    lastChecked: "2026-10-02",
    gscImpressions: 344,
    gscClicks: 1
  },
  {
    id: "kw-gsc-10",
    market: "SE",
    keyword: "personliga lån",
    currentPosition: 55.5,
    previousPosition: 56.7,
    change: 1,
    searchVolume: 200,
    difficulty: 45,
    targetUrl: "/privatlan",
    intent: "commercial",
    status: "ranking",
    lastChecked: "2026-10-02",
    gscImpressions: 2,
    gscClicks: 1
  },
  {
    id: "kw-gsc-11",
    market: "SE",
    keyword: "simply loan trustpilot",
    currentPosition: 2.3,
    previousPosition: 3.5,
    change: 1,
    searchVolume: 200,
    difficulty: 45,
    targetUrl: "/privatlan",
    intent: "commercial",
    status: "ranking",
    lastChecked: "2026-10-02",
    gscImpressions: 6,
    gscClicks: 1
  },
  {
    id: "kw-gsc-12",
    market: "SE",
    keyword: "100000 kr",
    currentPosition: 82,
    previousPosition: 83.2,
    change: 1,
    searchVolume: 200,
    difficulty: 45,
    targetUrl: "/privatlan",
    intent: "commercial",
    status: "ranking",
    lastChecked: "2026-10-02",
    gscImpressions: 1,
    gscClicks: 0
  },
  {
    id: "kw-gsc-13",
    market: "SE",
    keyword: "500 loan",
    currentPosition: 79,
    previousPosition: 80.2,
    change: 1,
    searchVolume: 200,
    difficulty: 45,
    targetUrl: "/privatlan",
    intent: "commercial",
    status: "ranking",
    lastChecked: "2026-10-02",
    gscImpressions: 1,
    gscClicks: 0
  },
  {
    id: "kw-gsc-14",
    market: "SE",
    keyword: "5000 personal loan",
    currentPosition: 46,
    previousPosition: 47.2,
    change: 1,
    searchVolume: 200,
    difficulty: 45,
    targetUrl: "/privatlan",
    intent: "commercial",
    status: "ranking",
    lastChecked: "2026-10-02",
    gscImpressions: 1,
    gscClicks: 0
  },
  {
    id: "kw-gsc-15",
    market: "SE",
    keyword: "50000 loan",
    currentPosition: 58,
    previousPosition: 59.2,
    change: 1,
    searchVolume: 200,
    difficulty: 45,
    targetUrl: "/privatlan",
    intent: "commercial",
    status: "ranking",
    lastChecked: "2026-10-02",
    gscImpressions: 1,
    gscClicks: 0
  },
  {
    id: "kw-gsc-16",
    market: "SE",
    keyword: "50000 personal loan",
    currentPosition: 56,
    previousPosition: 57.2,
    change: 1,
    searchVolume: 200,
    difficulty: 45,
    targetUrl: "/privatlan",
    intent: "commercial",
    status: "ranking",
    lastChecked: "2026-10-02",
    gscImpressions: 1,
    gscClicks: 0
  },
  // Norwegian keywords
  {
    id: "kw-no-1",
    market: "NO",
    keyword: "refinansiering av forbrukslån",
    currentPosition: 16,
    previousPosition: 19,
    change: 3,
    searchVolume: 5400,
    difficulty: 62,
    targetUrl: "/no/refinansiering",
    intent: "transactional",
    status: "rising",
    lastChecked: "2026-10-01",
    gscImpressions: 310,
    gscClicks: 14
  },
  {
    id: "kw-no-2",
    market: "NO",
    keyword: "hva er effektiv rente",
    currentPosition: 8,
    previousPosition: 10,
    change: 2,
    searchVolume: 2800,
    difficulty: 29,
    targetUrl: "/no/guide/hva-er-effektiv-rente",
    intent: "informational",
    status: "ranking",
    lastChecked: "2026-10-01",
    gscImpressions: 540,
    gscClicks: 41
  }
];

export const INITIAL_COMPETITORS: CompetitorItem[] = [
  {
    id: "comp-1",
    market: "SE",
    name: "Swiftbanker Sverige",
    domain: "swiftbanker.se",
    category: "affiliate",
    metaLibrarySearch: "Swiftbanker",
    googleAdsSearch: "swiftbanker.se",
    topLandingPages: [
      { title: "Låneöversikt Quiz", path: "https://swiftbanker.se" },
      { title: "Privatlån jämförelse", path: "https://swiftbanker.se/privatlan" }
    ],
    keyStrengths: "Ejes af Lacuna Digital ApS (Kbh). Meget aggressiv paid acquisition på Meta Ads, TikTok og Google. Bruger multi-step lead capture quiz før listerne vises.",
    observedAdHooks: [
      "Få 3 skräddarsydda låneerbjudanden på under 2 minuter",
      "Har du lån i banken? Testa om du betalar för mycket i onödan",
      "Nytt låneöversikt 2026: Se var du har störst chans att bli beviljad"
    ],
    notes: "Kører 100% paid media arbitrage. Videresender alle leads til Sambla, Enklare og Ferratum."
  },
  {
    id: "comp-2",
    market: "SE",
    name: "Matchbanker Sverige",
    domain: "matchbanker.se",
    category: "affiliate",
    metaLibrarySearch: "Matchbanker",
    googleAdsSearch: "matchbanker.se",
    topLandingPages: [
      { title: "Jämför lån lista", path: "https://matchbanker.se" },
      { title: "Lån utan UC", path: "https://matchbanker.se/lan-utan-uc/" },
      { title: "Snabblån", path: "https://matchbanker.se/snabblan/" }
    ],
    keyStrengths: "Ejes af Karman Connect A/S (Aarhus). Skandinaviens største låne-affiliate. Massiv organisk SEO-autoritet på 'lån utan uc' og 'snabblån'.",
    observedAdHooks: [
      "Se vilka lån du kan få beviljade direkt på skärmen",
      "Jämför över 30 långivare kostnadsfritt med 1 ansökan",
      "Undvik avslag: Se långivarna som godkänner flest ansökningar i dag"
    ],
    notes: "Tung SEO-konkurrent. Kører også Meta ads med sammenligningstabeller."
  },
  {
    id: "comp-3",
    market: "SE",
    name: "Arcadia Finans Sverige",
    domain: "arcadiafinans.se",
    category: "affiliate",
    metaLibrarySearch: "Arcadia Finans",
    googleAdsSearch: "arcadiafinans.se",
    topLandingPages: [
      { title: "Samla lån formulär", path: "https://arcadiafinans.se" },
      { title: "Privatlån", path: "https://arcadiafinans.se/privatlan" }
    ],
    keyStrengths: "Ejes af finske Draivi Media Oy. Enorme annoncebudgetter på Meta Ads og Native Ads (Taboola/Outbrain). Ekstremt optimeret 1-sides ansøgning.",
    observedAdHooks: [
      "Samla dina dyra smålån och sänk månadskostnaden direkt",
      "Låna från 5 000 till 600 000 kr – Svar direkt från anslutna banker",
      "Dålig kreditvärdighet? Här är bankerna med individuell prövning"
    ],
    notes: "Aggressiv affiliate-arbitrage. Sender trafikken videre til Sambla og nischbanker."
  },
  {
    id: "comp-4",
    market: "SE",
    name: "Moneezy / Fair-lån",
    domain: "moneezy.com",
    category: "affiliate",
    metaLibrarySearch: "Moneezy",
    googleAdsSearch: "moneezy.com",
    topLandingPages: [
      { title: "Moneezy Sverige", path: "https://moneezy.com/se/" },
      { title: "Fair-lån Sverige", path: "https://fair-laan.se" }
    ],
    keyStrengths: "Ejes af Intelligent Banker ApS (Odense). Grundlagt 2009 med aktiviteter i 15+ lande. Stærke historiske backlinks og filtreringsmotor.",
    observedAdHooks: [
      "Låneöversikt 2026: Jämför räntor och villkor innan du ansöker",
      "Hitta marknadens lägsta ränta med vår smarta lånekalkylator"
    ],
    notes: "Fokuseret på ren sammenligning med Trustpilot-badges og slider-kalkulatorer."
  },
  {
    id: "comp-5",
    market: "SE",
    name: "Klara Lån",
    domain: "klaralan.se",
    category: "affiliate",
    metaLibrarySearch: "Klara Lån",
    googleAdsSearch: "klaralan.se",
    topLandingPages: [
      { title: "Lån utan UC", path: "https://klaralan.se" }
    ],
    keyStrengths: "Zentro Finans AB. Total dominans i Sverige inden for snabblån, smålån og Creditsafe/Bisnode lån.",
    observedAdHooks: [
      "Låna pengar utan UC – Svar och utbetalning med BankID på 5 min",
      "Ansök om lån trots betalningsanmärkning – individuell bedömning"
    ],
    notes: "Direkte konkurrent på målgruppen med betalningsanmärkningar og akut lånebehov."
  },
  // Norwegian competitors
  {
    id: "comp-no-1",
    market: "NO",
    name: "Swiftbanker Norge",
    domain: "swiftbanker.no",
    category: "affiliate",
    metaLibrarySearch: "Swiftbanker",
    googleAdsSearch: "swiftbanker.no",
    topLandingPages: [
      { title: "Låneoversikt Quiz", path: "https://swiftbanker.no" }
    ],
    keyStrengths: "Lacuna Digital. Kører aggressiv lead capture via Meta Ads rettet mod nordmænd med forbrugsgæld.",
    observedAdHooks: [
      "Finn det billigste lånet i Norge på 2 minutter",
      "Refinansiering: Kutt rentekostnadene på dine smålån"
    ],
    notes: "Sender leads videre til Axo Finans, Sambla og norske banker."
  },
  {
    id: "comp-no-2",
    market: "NO",
    name: "Matchbanker Norge",
    domain: "matchbanker.no",
    category: "affiliate",
    metaLibrarySearch: "Matchbanker",
    googleAdsSearch: "matchbanker.no",
    topLandingPages: [
      { title: "Sammenlign lån", path: "https://matchbanker.no" }
    ],
    keyStrengths: "Karman Connect. Høj synlighed på Google på 'forbrukslån' og 'refinansiering uten sikkerhet'.",
    observedAdHooks: [
      "Se hvilke banker som innvilger lån til deg i dag",
      "Uforpliktende sammenligning av over 20 norske långivere"
    ],
    notes: "Stærk SEO-spiller i Norge."
  },
  {
    id: "comp-no-3",
    market: "NO",
    name: "Arcadia Finans Norge",
    domain: "arcadiafinans.no",
    category: "affiliate",
    metaLibrarySearch: "Arcadia Finans",
    googleAdsSearch: "arcadiafinans.no",
    topLandingPages: [
      { title: "Refinansiering", path: "https://arcadiafinans.no" }
    ],
    keyStrengths: "Draivi Media. Høj spend på Facebook Ads med fokus på gældssanering og rentebesparelser.",
    observedAdHooks: [
      "Refinansier dyr gjeld – spar tusenvis av kroner hver måned",
      "Lån inntil 500 000 kr uten sikkerhet i bolig"
    ],
    notes: "Aggressiv display- og social media-køber."
  }
];

export const DEFAULT_SETTINGS: PusherSettings = {
  enabled: true,
  activeDays: ["Tuesday", "Thursday"],
  windowStart: "09:30",
  windowEnd: "16:00",
  jitterMinutes: 45,
  targetBufferMinDays: 7,
  autoDeployToLightsail: true,
  notifyOnLowBuffer: true
};

export const DEFAULT_INTEGRATIONS: SeoIntegrationSettings = {
  gscSiteUrl: "https://simplyloan.se/",
  gscConnected: true,
  gscDnsVerified: true,
  googleIndexingServiceAccountConfigured: true,
  googleIndexingProjectEmail: "campaignschedulersa@campaign-scheduler-463311.iam.gserviceaccount.com"
};
